import sharedCardCarousel from './shared-card-carousel';

export default function storyCarousel(root: HTMLElement): void {
  sharedCardCarousel(root);
}
